import { render } from "./Enterprise_en.vue?vue&type=template&id=2bab84aa"
import script from "./Enterprise_en.vue?vue&type=script&lang=js"
export * from "./Enterprise_en.vue?vue&type=script&lang=js"
script.render = render

export default script